"use client";

import { useState } from "react";
import chevronDown from "@/assets/images/livescore/chevron-down.svg";
import LiveScoreMatch from "../LiveScoreMatch";

export default function LiveScoreMatchLeagues({ 
  league, 
  matches, 
  lastTableMatchId,
  onShowPopup, 
  onHidePopup, 
  activePopup, 
  render 
}) {
  const [collapsed, setCollapsed] = useState(false);

  const leagueMatches = matches || league?.matches || [];
  const leagueLogo = league?.logo || league?.leagueLogo;
  const leagueName = league?.name || league?.leagueName || "Unknown League";

  return (
    <tbody className="table-row-group w-full" data-expanded={collapsed ? "false" : "true"}>
      <tr
        className="kbv-cs-bg-header-bar box-border table-row h-[30px] w-full cursor-pointer"
        onClick={() => setCollapsed(!collapsed)}
      >
        <td
          colSpan={14}
          className="table-cell w-full border-b border-t-0 border-x-0 border-solid border-[color:var(--theme-border)] py-1 max-md:px-1.5 md:px-2"
        >
          <div className="flex items-center justify-between">
            <div className="flex min-w-0 flex-1 items-center gap-2 pl-1.5 max-md:gap-1.5 md:pl-[34px]">
              {leagueLogo ? (
                <img
                  src={leagueLogo}
                  alt=""
                  className="h-3.5 w-3.5 shrink-0 object-contain max-md:h-3 max-md:w-3 md:h-4 md:w-4"
                  width={16}
                  height={16}
                  loading="lazy"
                />
              ) : null}
              <span className="kbv-cs-text-league-mobile min-w-0 truncate max-md:text-[10px] max-md:font-medium max-md:leading-[15px] md:text-[12px] md:font-bold md:text-[color:var(--theme-text-muted)]">
                {leagueName}
              </span>
            </div>
            <span className="inline-flex" aria-hidden>
              <img
                src={chevronDown}
                alt=""
                className={`h-3 w-3 object-contain transition-transform duration-200 mr-1 ${collapsed ? "" : "rotate-180"}`}
              />
            </span>
          </div>
        </td>
      </tr>

      {/* Matches */}
      {!collapsed && leagueMatches.map((match, idx) => (
        render ? render(match, idx, { onShowPopup, onHidePopup, activePopup }) : (
          <LiveScoreMatch 
            key={match.id} 
            match={match} 
            isLastInTable={
              lastTableMatchId != null && String(match?.id) === String(lastTableMatchId)
            }
            onShowPopup={onShowPopup}
            onHidePopup={onHidePopup}
            activePopup={activePopup}
          />
        )
      ))}
    </tbody>
  );
}
